import { uploadFileToBase64String } from "../../../../../common/utils/utils";
import { ICreateProjetoRevisaoUseCase } from "../../../presentation/useCases/create/create_projeto_revisao_use_case";

import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * CreateProjetoRevisaoUseCase
 */

export class CreateProjetoRevisaoUseCase implements ICreateProjetoRevisaoUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(
    idProjeto: number,
    idCentroCusto: number,
    idFuncionarioSolicitante: number,
    dataSolicitacao?: Date,
    descricao?: string,

    arquivo1?: File,
    arquivo2?: File,

    disciplinasIds?: number[],

  ): Promise<number> {

    const nomeArquivo1ToSend = arquivo1 ? arquivo1.name : undefined;
    const nomeArquivo2ToSend = arquivo2 ? arquivo2.name : undefined;

    return await this.repository.createProjetoRevisao(
      idProjeto,
      idCentroCusto,
      idFuncionarioSolicitante,
      dataSolicitacao,
      descricao,
      nomeArquivo1ToSend,
      arquivo1 ?? undefined,
      nomeArquivo2ToSend,
      arquivo2 ?? undefined,
      disciplinasIds,
    )

  }
}
